import { Directive, HostListener, inject, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[addLeadingZero]',
  standalone: true,
})
export class InputAddLeadingZeroDirective implements OnInit {
  private ngControl = inject(NgControl);

  @Input() minimalStringLength: number | undefined = undefined;

  ngOnInit(): void {
    const value = this.ngControl.control?.value;
    if (value) {
      this.ngControl.control?.setValue(value.toString(), { emitEvent: false });
      this.onFocusOut();
    }
  }

  @HostListener('focusout')
  onFocusOut() {
    if (this.minimalStringLength !== undefined) {
      const value = this.ngControl.control?.value;
      if (value.length > 0) {
        const paddedValue = value.padStart(this.minimalStringLength, '0');
        if (value !== paddedValue) {
          this.ngControl.control?.setValue(paddedValue, { emitEvent: false });
        }
      }
    }
  }
}
